module.exports = __webpack_public_path__ + "static/img/case8.768c3a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/case8.png
// module id = cJle
// module chunks = 1